export default __webpack_public_path__ + "static/media/photo--lg--huda-1.08d89ace.jpg";